import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  standalone: false
})
export class PaginationComponent {
  @Input() totalPages: number = 1;

  @Output() pageChange = new EventEmitter<number>();

  currentPage: number = 1;

  get isFirstPage(): boolean {
    return this.currentPage === 1;
  }

  get isLastPage(): boolean {
    return this.currentPage === this.totalPages;
  }

  changePage(page: number): void {
    this.pageChange.emit(page);
    this.currentPage = page
  }
}
